export * from './generated';
export * from './schema';

import type {
  Wws_Error,
  Wws_WeddingWebsiteV2,
  Query,
  Maybe,
  Wws_AccommodationItem,
  Wws_ActivityItem,
  Wws_TransportationItem,
  Wws_Page,
  Wws_EventGroupItem,
  Wws_HeadlineItem,
  Wws_PageItem,
} from './schema';

export type Wws_WeddingWebsiteResult = Wws_Error | Wws_WeddingWebsiteV2;

export type WeddingWebsiteQuery = Omit<Query, 'weddingWebsiteResult'> & {
  weddingWebsiteResult?: Maybe<Wws_WeddingWebsiteResult>;
};

export function isWwsPages(
  pages: Partial<Wws_Page>[] | Error | undefined
): pages is Wws_Page[] {
  return !Array.isArray(pages);
}

export type Wws_BusinessItem =
  | Wws_AccommodationItem
  | Wws_ActivityItem
  | Wws_TransportationItem;

type WeddingWebsiteResult = WeddingWebsiteQuery['weddingWebsiteResult'];

export function isWwsError(
  weddingWebsiteResult?: Maybe<WeddingWebsiteResult>
): weddingWebsiteResult is Wws_Error {
  return weddingWebsiteResult?.__typename === 'WWS_Error';
}

export function isWwsWeddingWebsiteV2(
  weddingWebsiteResult?: Maybe<WeddingWebsiteResult>
): weddingWebsiteResult is Wws_WeddingWebsiteV2 {
  return weddingWebsiteResult?.__typename === 'WWS_WeddingWebsiteV2';
}

export function isAccommodationItem(
  item: Maybe<Wws_PageItem>
): item is Wws_AccommodationItem {
  return item?.type === 'AccommodationItem';
}

export function isEventGroupItem(
  item: Wws_PageItem & { __typename?: string }
): item is Wws_EventGroupItem {
  return item?.__typename === 'WWS_EventGroupItem';
}

export function isHeadlineItem(
  item: Wws_PageItem & { __typename?: string }
): item is Wws_HeadlineItem {
  return item?.__typename === 'WWS_HeadlineItem';
}
